import {
  EDIT_FIRST_NAME_QUICK_REGISTER, EDIT_LAST_NAME_QUICK_REGISTER,
  EDIT_SURNAME_QUICK_REGISTER,
  EDIT_EMAIL_QUICK_REGISTER, RESET_QUICK_REGISTER_FORM,
  EDIT_PHONE_QUICK_REGISTER, SWITCH_CHECKBOX_PERMISSION_QUICK
} from "../actions/quick_register_form_actions";


const initialState = {
  first_name: '',
  last_name: '',
  surname: '',
  email: '',
  phone: '',
  checkbox_permission: null
};

export const quickRegisterFormReducer = (state = initialState, action) => {
  switch (action.type) {
    case EDIT_FIRST_NAME_QUICK_REGISTER: {
      return {
        ...state,
        first_name: action.first_name
      }
    }
    case EDIT_LAST_NAME_QUICK_REGISTER: {
      return {
        ...state,
        last_name: action.last_name
      }
    }
    case EDIT_SURNAME_QUICK_REGISTER: {
      return {
        ...state,
        surname: action.surname
      }
    }
    case EDIT_EMAIL_QUICK_REGISTER: {
      return {
        ...state,
        email: action.email
      }
    }
    case EDIT_PHONE_QUICK_REGISTER: {
      return {
        ...state,
        phone: action.phone
      }
    }
    case RESET_QUICK_REGISTER_FORM: {
      return {
        ...state,
        first_name: '',
        last_name: '',
        surname: '',
        email: '',
        phone: '',
        checkbox_permission: null
      }
    }
    case SWITCH_CHECKBOX_PERMISSION_QUICK: {
      return {
        ...state,
        checkbox_permission: action.checkbox_permission
      }
    }
    default: {
      return state;
    }
  }
}
